import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { AISidebar, AIInsightCard } from '../components/ai';
import { AIOutlineButton } from '../components/ui/AIOutlineButton';
import { laSaponariaLocations } from '../utils/locations';
import { exportToCSV } from '../utils/exportCSV';
import { Search, Filter, Download, X, CheckCircle, Clock, Calendar, ArrowUpDown, Gem, Receipt, ShoppingBag } from 'lucide-react';
// Mock claims data - Updated with new structure
const mockClaims = [{
  id: 'RC-1001-2026',
  actionType: 'Riscatto',
  method: 'In Sede',
  date: '15/03/2026',
  time: '14:32',
  code: 'SIERO-HA-001',
  reward: 'Siero Acido Ialuronico Multi-Peso',
  diamonds: 50,
  location: 'Milano Centro',
  userId: 'USR-8A3F2',
  status: 'Utilizzato',
  notes: 'Prodotto ritirato presso il negozio.',
  timeline: [{
    status: 'Riscattato',
    date: '15/03/2026 14:32',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '16/03/2026 09:20',
    completed: true
  }]
}, {
  id: 'UT-1002-2026',
  actionType: 'Utilizzo',
  method: 'Online',
  date: '16/03/2026',
  time: '10:15',
  code: 'SOLIDI-KIT-002',
  reward: 'Kit Cosmetici Solidi Zero Waste',
  diamonds: 50,
  location: '',
  userId: 'USR-9B4C1',
  status: 'Utilizzato',
  notes: 'Codice utilizzato per acquisto online.',
  timeline: [{
    status: 'Riscattato',
    date: '16/03/2026 10:15',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '16/03/2026 10:15',
    completed: true
  }]
}, {
  id: 'RC-1003-2026',
  actionType: 'Riscatto',
  method: 'In Sede',
  date: '18/03/2026',
  time: '11:45',
  code: 'CREMA-VISO-003',
  reward: 'Crema Viso Deep Care Anti-Age',
  diamonds: 50,
  location: 'Bologna',
  userId: 'USR-2D5E8',
  status: 'Riscattato',
  notes: 'Premio fisico. Ritiro previsto presso la sede.',
  timeline: [{
    status: 'Riscattato',
    date: '18/03/2026 11:45',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '-',
    completed: false
  }]
}, {
  id: 'UT-1004-2026',
  actionType: 'Utilizzo',
  method: 'In Sede',
  date: '20/03/2026',
  time: '16:20',
  code: 'WORK-005',
  reward: 'Workshop Cosmetici Fai-da-Te',
  diamonds: 100,
  location: 'Pesaro (Sede e Spaccio)',
  userId: 'USR-7F3A9',
  status: 'Utilizzato',
  notes: 'Workshop completato con successo.',
  timeline: [{
    status: 'Riscattato',
    date: '20/03/2026 16:20',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '20/03/2026 18:30',
    completed: true
  }]
}, {
  id: 'UT-1005-2026',
  actionType: 'Utilizzo',
  method: 'Online',
  date: '22/03/2026',
  time: '09:30',
  code: 'VOUCHER-20',
  reward: 'Buono Sconto 20€ su Acquisto',
  diamonds: 40,
  location: '',
  userId: 'USR-1C6D2',
  status: 'Utilizzato',
  notes: 'Codice utilizzato per acquisto online.',
  timeline: [{
    status: 'Riscattato',
    date: '22/03/2026 09:30',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '22/03/2026 14:45',
    completed: true
  }]
}, {
  id: 'RC-1006-2026',
  actionType: 'Riscatto',
  method: 'In Sede',
  date: '25/03/2026',
  time: '15:20',
  code: 'HENNE-004',
  reward: 'Set Hennetica Tinte Vegetali',
  diamonds: 60,
  location: 'Firenze',
  userId: 'USR-3E7B9',
  status: 'Riscattato',
  notes: 'In attesa di ritiro con consulenza colorazione.',
  timeline: [{
    status: 'Riscattato',
    date: '25/03/2026 15:20',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '-',
    completed: false
  }]
}, {
  id: 'UT-1007-2026',
  actionType: 'Utilizzo',
  method: 'In Sede',
  date: '28/03/2026',
  time: '10:15',
  code: 'CORPO-AHA-007',
  reward: 'Crema Corpo AHA Levigante',
  diamonds: 45,
  location: 'Milano Solari',
  userId: 'USR-4F8C3',
  status: 'Utilizzato',
  notes: 'Prodotto ritirato con campioni omaggio.',
  timeline: [{
    status: 'Riscattato',
    date: '28/03/2026 10:15',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '28/03/2026 10:15',
    completed: true
  }]
}, {
  id: 'RC-1008-2026',
  actionType: 'Riscatto',
  method: 'In Sede',
  date: '30/03/2026',
  time: '14:50',
  code: 'SIERO-HA-001',
  reward: 'Siero Acido Ialuronico Multi-Peso',
  diamonds: 50,
  location: 'Roma Cola di Rienzo',
  userId: 'USR-5G9D4',
  status: 'Riscattato',
  notes: 'Premio in attesa di ritiro.',
  timeline: [{
    status: 'Riscattato',
    date: '30/03/2026 14:50',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '-',
    completed: false
  }]
}];
const Claims = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [filteredClaims, setFilteredClaims] = useState(mockClaims);
  const [selectedClaim, setSelectedClaim] = useState<any>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Filters
  const [actionFilter, setActionFilter] = useState('Tutti');
  const [methodFilter, setMethodFilter] = useState('Tutti');
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  // Sorting
  const [sortConfig, setSortConfig] = useState<{
    key: string | null;
    direction: 'asc' | 'desc' | null;
  }>({
    key: null,
    direction: null
  });
  // Handle URL params for filtering (from notifications)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const filterType = params.get('filter');
    if (filterType === 'riscatti') {
      setActionFilter('Riscatto');
    } else if (filterType === 'utilizzi') {
      setActionFilter('Utilizzo');
    }
  }, [location.search]);
  useEffect(() => {
    let result = [...mockClaims];
    if (actionFilter !== 'Tutti') {
      result = result.filter(claim => claim.actionType === actionFilter);
    }
    if (methodFilter !== 'Tutti') {
      result = result.filter(claim => claim.method === methodFilter);
    }
    if (searchTerm) {
      result = result.filter(claim => claim.id.toLowerCase().includes(searchTerm.toLowerCase()) || claim.code.toLowerCase().includes(searchTerm.toLowerCase()) || claim.reward.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    // Date filtering
    if (dateFrom) {
      result = result.filter(claim => {
        const [day, month, year] = claim.date.split('/');
        const claimDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        const fromDate = new Date(dateFrom);
        return claimDate >= fromDate;
      });
    }
    if (dateTo) {
      result = result.filter(claim => {
        const [day, month, year] = claim.date.split('/');
        const claimDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        const toDate = new Date(dateTo);
        return claimDate <= toDate;
      });
    }
    // Sorting
    if (sortConfig.key && sortConfig.direction) {
      result.sort((a: any, b: any) => {
        let aValue = a[sortConfig.key!];
        let bValue = b[sortConfig.key!];
        if (sortConfig.key === 'date') {
          const [dayA, monthA, yearA] = a.date.split('/');
          const [dayB, monthB, yearB] = b.date.split('/');
          aValue = new Date(parseInt(yearA), parseInt(monthA) - 1, parseInt(dayA)).getTime();
          bValue = new Date(parseInt(yearB), parseInt(monthB) - 1, parseInt(dayB)).getTime();
        }
        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    setFilteredClaims(result);
  }, [actionFilter, methodFilter, searchTerm, dateFrom, dateTo, sortConfig]);
  const handleSort = (key: string) => {
    let direction: 'asc' | 'desc' | null = 'asc';
    if (sortConfig.key === key) {
      if (sortConfig.direction === 'asc') {
        direction = 'desc';
      } else if (sortConfig.direction === 'desc') {
        direction = null;
      }
    }
    setSortConfig({
      key: direction ? key : null,
      direction
    });
  };
  const handleRowClick = (claim: any) => {
    setSelectedClaim(claim);
    setIsDrawerOpen(true);
  };
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setTimeout(() => setSelectedClaim(null), 300);
  };
  const handleExportCSV = () => {
    // Prepare data for CSV export
    const csvData = filteredClaims.map(claim => ({
      'ID Azione': claim.id,
      Azione: claim.actionType,
      Metodo: claim.method,
      Data: claim.date,
      Ora: claim.time,
      Codice: claim.code,
      'Nome Premio': claim.reward,
      Punti: claim.diamonds,
      Sede: claim.location || '-'
    }));
    const headers = ['ID Azione', 'Azione', 'Metodo', 'Data', 'Ora', 'Codice', 'Nome Premio', 'Punti', 'Sede'];
    exportToCSV(csvData, 'GB_Partner.csv', headers);
  };
  const getActionIcon = (actionType: string) => {
    switch (actionType) {
      case 'Riscatto':
        return <Receipt className="h-4 w-4 text-gray-500" data-id="element-944" />;
      case 'Utilizzo':
        return <ShoppingBag className="h-4 w-4 text-gray-500" data-id="element-945" />;
      default:
        return null;
    }
  };
  const SortableHeader = ({
    label,
    sortKey,
    className = ''
  }: {
    label: string;
    sortKey: string;
    className?: string;
  }) => {
    const isSorted = sortConfig.key === sortKey;
    return <th className={`px-4 py-3 cursor-pointer select-none ${className}`} onClick={() => handleSort(sortKey)} data-id="element-946">
        <div className="flex items-center justify-between whitespace-nowrap" data-id="element-947">
          <span data-id="element-948">{label}</span>
          <ArrowUpDown className={`h-3 w-3 ml-1 ${isSorted ? 'text-green-600' : 'text-gray-400'}`} data-id="element-949" />
        </div>
      </th>;
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-950">
      {/* Desktop Sidebar Wrapper - Hidden on Mobile */}
      <div className="hidden lg:block w-20 flex-shrink-0" data-id="element-951">
        <Sidebar data-id="element-952" />
      </div>

      {/* Mobile Sidebar - Overlay */}
      <div className="lg:hidden" data-id="element-953">
        <Sidebar mobileOpen={sidebarOpen} onMobileClose={() => setSidebarOpen(false)} data-id="element-954" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-955">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-956" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-957">
          {/* Header with AI Button */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4" data-id="element-958">
            <div data-id="element-959">
              <h1 className="text-2xl font-semibold text-gray-900" data-id="element-960">
                Riscatti e Utilizzi
              </h1>
              <p className="text-sm text-gray-500 mt-1" data-id="element-961">
                Storico dei premi riscattati e utilizzati (dati pseudonimi).
              </p>
            </div>
            <AIOutlineButton onClick={() => setIsAISidebarOpen(true)} title="AI Insights" data-id="element-962">
              Suggerimenti AI
            </AIOutlineButton>
          </div>

          {/* Filters */}
          <div className="mb-6 flex flex-wrap gap-3 items-center" data-id="element-963">
            <div className="relative w-full sm:w-auto" data-id="element-964">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" data-id="element-965" />
              <input type="text" placeholder="Cerca ID azione, codice o premio..." className="w-full sm:w-auto rounded-lg border border-gray-300 pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-greenback" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-966" />
            </div>

            {/* Date From */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 gap-2 w-full sm:w-auto" data-id="element-967">
              <Calendar className="h-4 w-4 text-gray-500" data-id="element-968" />
              <span className="text-sm text-gray-600 whitespace-nowrap" data-id="element-969">
                Da:
              </span>
              <input type="date" className="bg-transparent text-sm focus:outline-none w-full" value={dateFrom} onChange={e => setDateFrom(e.target.value)} data-id="element-970" />
            </div>

            {/* Date To */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 gap-2 w-full sm:w-auto" data-id="element-971">
              <Calendar className="h-4 w-4 text-gray-500" data-id="element-972" />
              <span className="text-sm text-gray-600 whitespace-nowrap" data-id="element-973">
                A:
              </span>
              <input type="date" className="bg-transparent text-sm focus:outline-none w-full" value={dateTo} onChange={e => setDateTo(e.target.value)} data-id="element-974" />
            </div>

            {/* Action Filter */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 w-full sm:w-auto" data-id="element-975">
              <Filter className="mr-2 h-4 w-4 text-gray-500" data-id="element-976" />
              <select className="bg-transparent text-sm focus:outline-none text-gray-700 w-full" value={actionFilter} onChange={e => setActionFilter(e.target.value)} data-id="element-977">
                <option value="Tutti" className="text-sm" data-id="element-978">
                  Tutte le azioni
                </option>
                <option value="Riscatto" className="text-sm" data-id="element-979">
                  Riscatto
                </option>
                <option value="Utilizzo" className="text-sm" data-id="element-980">
                  Utilizzo
                </option>
              </select>
            </div>

            {/* Method Filter */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 w-full sm:w-auto" data-id="element-981">
              <Filter className="mr-2 h-4 w-4 text-gray-500" data-id="element-982" />
              <select className="bg-transparent text-sm focus:outline-none text-gray-700 w-full" value={methodFilter} onChange={e => setMethodFilter(e.target.value)} data-id="element-983">
                <option value="Tutti" className="text-sm" data-id="element-984">
                  Tutti i metodi
                </option>
                <option value="In Sede" className="text-sm" data-id="element-985">
                  In Sede
                </option>
                <option value="Online" className="text-sm" data-id="element-986">
                  Online
                </option>
              </select>
            </div>

            {/* Esporta CSV - Tertiary Button (text-only, right-aligned) */}
            <button onClick={handleExportCSV} className="ml-auto text-sm text-gray-600 hover:text-gray-900 hover:underline transition-colors inline-flex items-center gap-1.5" data-id="element-987">
              <Download className="h-4 w-4" data-id="element-988" />
              Esporta CSV
            </button>
          </div>

          {/* Table */}
          <div className="rounded-lg border border-gray-200 bg-white overflow-hidden" data-id="element-989">
            <div className="overflow-x-auto" data-id="element-990">
              <table className="w-full" data-id="element-991">
                <thead data-id="element-992">
                  <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-993">
                    <SortableHeader label="ID Azione" sortKey="id" data-id="element-994" />
                    <SortableHeader label="Azione" sortKey="actionType" data-id="element-995" />
                    <SortableHeader label="Metodo" sortKey="method" data-id="element-996" />
                    <SortableHeader label="Data" sortKey="date" data-id="element-997" />
                    <SortableHeader label="Ora" sortKey="time" data-id="element-998" />
                    <SortableHeader label="Codice" sortKey="code" data-id="element-999" />
                    <SortableHeader label="Nome Premio" sortKey="reward" className="min-w-[160px]" data-id="element-1000" />
                    <SortableHeader label="Punti" sortKey="diamonds" data-id="element-1001" />
                    <SortableHeader label="Sede" sortKey="location" data-id="element-1002" />
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200" data-id="element-1003">
                  {filteredClaims.map(claim => <tr key={claim.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleRowClick(claim)} data-id="element-1004">
                      <td className="px-4 py-4" data-id="element-1005">
                        <span className="font-mono text-sm font-medium text-gray-900" data-id="element-1006">
                          {claim.id}
                        </span>
                      </td>
                      <td className="px-4 py-4" data-id="element-1007">
                        <div className="flex items-center gap-2" data-id="element-1008">
                          {getActionIcon(claim.actionType)}
                          <span className="text-sm text-gray-900" data-id="element-1009">
                            {claim.actionType}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1010">
                        {claim.method}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1011">
                        {claim.date}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1012">
                        {claim.time}
                      </td>
                      <td className="px-4 py-4" data-id="element-1013">
                        <span className="font-mono text-sm text-gray-700" data-id="element-1014">
                          {claim.code}
                        </span>
                      </td>
                      <td className="px-4 py-4" style={{
                    minWidth: '160px'
                  }} data-id="element-1015">
                        <div className="font-medium text-gray-900" data-id="element-1016">
                          {claim.reward}
                        </div>
                      </td>
                      <td className="px-4 py-4 font-medium" data-id="element-1017">
                        <div className="flex items-center gap-1" data-id="element-1018">
                          <Gem className="h-3.5 w-3.5 text-gray-500" data-id="element-1019" />
                          <span data-id="element-1020">{claim.diamonds}</span>
                        </div>
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1021">
                        {claim.location || '-'}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          {filteredClaims.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-1022">
              <p data-id="element-1023">
                Nessun riscatto o utilizzo trovato con i filtri selezionati.
              </p>
            </div>}
        </main>
      </div>

      {/* AI Sidebar */}
      <AISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} title="Suggerimenti AI per Riscatti e Utilizzi" data-id="element-1024">
        <AIInsightCard title="AI: Lettura del periodo" insights={['I riscatti aumentano soprattutto su cosmetici solidi zero-waste (+25%).', 'Picco di utilizzi online negli ultimi 7 giorni (+18%).', 'Set Hennetica: calo conversione. Considera riduzione costo a 50 punti.', 'Workshop Cosmetici Fai-da-Te: alta domanda. Aumenta disponibilità del 30%.']} ctaLabel="Apri premi" onCtaClick={() => navigate('/rewards')} lastUpdated="Ultimi 7 giorni" data-id="element-1025" />
      </AISidebar>

      {/* Detail Drawer */}
      {isDrawerOpen && selectedClaim && <>
          <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={handleCloseDrawer} data-id="element-1026"></div>

          <div className={`fixed top-0 right-0 h-full w-full sm:w-[500px] bg-white shadow-xl z-50 overflow-y-auto transition-transform duration-300 ease-in-out ${isDrawerOpen ? 'transform-none' : 'translate-x-full'}`} data-id="element-1027">
            <div className="p-6" data-id="element-1028">
              <div className="flex items-center justify-between mb-6" data-id="element-1029">
                <h2 className="text-xl font-semibold" data-id="element-1030">Dettagli Azione</h2>
                <button onClick={handleCloseDrawer} className="rounded-full p-2 hover:bg-gray-100 transition-colors" data-id="element-1031">
                  <X className="h-5 w-5 text-gray-500" data-id="element-1032" />
                </button>
              </div>

              <div className="space-y-6" data-id="element-1033">
                <div data-id="element-1034">
                  <span className="font-mono text-sm text-gray-500" data-id="element-1035">
                    ID Azione
                  </span>
                  <p className="font-mono text-lg font-semibold mt-1" data-id="element-1036">
                    {selectedClaim.id}
                  </p>
                </div>

                <div data-id="element-1037">
                  <span className="text-sm text-gray-500" data-id="element-1038">Tipo Azione</span>
                  <p className="text-base font-medium mt-1" data-id="element-1039">
                    {selectedClaim.actionType}
                  </p>
                </div>

                <div data-id="element-1040">
                  <span className="text-sm text-gray-500" data-id="element-1041">Metodo</span>
                  <p className="text-base font-medium mt-1" data-id="element-1042">
                    {selectedClaim.method}
                  </p>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1043">
                  <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-1044">
                    Premio
                  </h3>
                  <p className="font-medium text-gray-900" data-id="element-1045">
                    {selectedClaim.reward}
                  </p>
                  <div className="flex items-center justify-between mt-2 text-sm" data-id="element-1046">
                    <span className="text-gray-500" data-id="element-1047">Codice:</span>
                    <span className="font-mono font-medium" data-id="element-1048">
                      {selectedClaim.code}
                    </span>
                  </div>
                  <div className="flex items-center justify-between mt-1 text-sm" data-id="element-1049">
                    <span className="text-gray-500" data-id="element-1050">Costo:</span>
                    <span className="font-medium flex items-center gap-1" data-id="element-1051">
                      <Gem className="h-3 w-3 text-gray-900" data-id="element-1052" />
                      {selectedClaim.diamonds}
                    </span>
                  </div>
                </div>

                <div data-id="element-1053">
                  <span className="text-sm text-gray-500" data-id="element-1054">Data e Ora</span>
                  <p className="text-base font-medium mt-1" data-id="element-1055">
                    {selectedClaim.date} alle {selectedClaim.time}
                  </p>
                </div>

                {selectedClaim.location && <div data-id="element-1056">
                    <span className="text-sm text-gray-500" data-id="element-1057">Sede</span>
                    <p className="text-base font-medium mt-1" data-id="element-1058">
                      {selectedClaim.location}
                    </p>
                  </div>}

                {/* Timeline */}
                <div data-id="element-1059">
                  <h3 className="text-sm font-medium text-gray-900 mb-4" data-id="element-1060">
                    Timeline
                  </h3>
                  <div className="space-y-4" data-id="element-1061">
                    {selectedClaim.timeline.map((step: any, index: number) => <div key={index} className="flex items-start" data-id="element-1062">
                        <div className="flex flex-col items-center mr-4" data-id="element-1063">
                          {step.completed ? <div className="flex items-center justify-center w-8 h-8 rounded-full bg-green-100" data-id="element-1064">
                              <CheckCircle className="h-5 w-5 text-green-600" data-id="element-1065" />
                            </div> : <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100" data-id="element-1066">
                              <Clock className="h-5 w-5 text-gray-400" data-id="element-1067" />
                            </div>}
                          {index < selectedClaim.timeline.length - 1 && <div className={`w-0.5 h-12 ${step.completed ? 'bg-green-200' : 'bg-gray-200'}`} data-id="element-1068"></div>}
                        </div>
                        <div className="flex-1 pb-4" data-id="element-1069">
                          <p className={`font-medium ${step.completed ? 'text-gray-900' : 'text-gray-400'}`} data-id="element-1070">
                            {step.status}
                          </p>
                          <p className="text-sm text-gray-500 mt-1" data-id="element-1071">
                            {step.date}
                          </p>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Notes */}
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200" data-id="element-1072">
                  <h3 className="text-sm font-medium text-blue-900 mb-2" data-id="element-1073">
                    Note
                  </h3>
                  <p className="text-sm text-blue-800" data-id="element-1074">{selectedClaim.notes}</p>
                </div>
              </div>
            </div>
          </div>
        </>}
    </div>;
};
export default Claims;